import { collection, where } from 'firebase/firestore';
import { firestore } from 'firebaseService/firebase';
import FirebaseFirestoreService from 'firebaseService/firebaseFirestore';

class ProjectsFirestoreService extends FirebaseFirestoreService {
  static collectionPath = 'projects';
  static collection = collection(firestore, this.collectionPath);

  static async createProject(values) {
    try {
      return await this.addDoc(this.collection, values);
    } catch (error) {
      return { success: false, error };
    }
  }

  static async getSize() {
    try {
      return await this.getRegisterCount(this.collection);
    } catch (error) {
      return { success: false, error };
    }
  }

  static async updateProject(id, project) {
    try {
      if (project.recentReject) {
        delete project.recentReject;
      } else if (['Revisado', 'Rechazado'].includes(project.status)) {
        project.status = 'Preparando Propuesta';
      }
      return await this.updateDoc(this.collectionPath, id, project);
    } catch (error) {
      return { success: false, error };
    }
  }

  static async getProjects() {
    try {
      const constrains = [where('isActive', '==', true)];
      return await this.getAllDocs(this.collection, constrains);
    } catch (error) {
      return { success: false, error };
    }
  }

  static subscribeToProjects(callBack, filters = {}) {
    try {
      const constrains = [where('isActive', '==', true)];
      if (filters.email) {
        constrains.push(where('responsable.email', '==', filters.email));
      }

      if (filters.status) {
        constrains.push(where('status', 'in', filters.status));
      }

      if (filters.dependencies) {
        constrains.push(where('ministerio', 'in', filters.dependencies));
      }

      if (filters.unstatus) {
        constrains.push(where('status', 'not-in', filters.unstatus));
      }

      const unsubscibe = FirebaseFirestoreService.subscribeToAllDocs(this.collection, constrains, callBack);
      return unsubscibe;
    } catch (error) {
      console.error(error);
      return { success: false, error };
    }
  }
}

export default ProjectsFirestoreService;
